<p>destroyable works!</p>
